import React from "react";
import "./ImageTextSection.scss";

const ImageTextSection = ({ image, textContent, imageOnLeft = true }) => {
  return (
    // 'image-on-left' veya 'image-on-right' class'ını dinamik olarak ekliyoruz
    <div
      className={`image-text-section ${
        imageOnLeft ? "image-on-left" : "image-on-right"
      }`}
    >
      <div className="its__image-column">
        <img src={image} alt="hakkımızda bölümü görseli" />
      </div>
      <div className="its__text-column">
        {/* Metni HTML olarak basmak yerine, her paragrafı bir <p> içine alalım */}
        {textContent.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
};

export default ImageTextSection;
